module.exports = __webpack_public_path__ + "static/img/1.68bde02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/1.png
// module id = kSMD
// module chunks = 0